import React, { useEffect } from 'react'
import './AdminPanelLayout.css'
import { ConfigurationDashboardNavbar } from '../configurationDashboardNavbar/configurationDashboardNavbar'
import { resetConfigDashboardTypes, setActiveConfigType } from '../../stateManagement/actions/configDashboardActions'
import { ConfigDashboardTypes } from '../../types'
import { getConfigurationTypes } from '../../services/uiConfigService'
import store from '../../stateManagement/store'


function AdminPanelLayout({children , resetNavOptions}: {children? : JSX.Element , resetNavOptions?:boolean}) {
  useEffect(() => {
    async function getNavbarConfigTypes(){
      const layoutConfig = store.getState()?.portalConfigState?.layoutConfig ?? [];
      const configTypes = (layoutConfig.find((configObj) => configObj.name === "mainDashboardLayout")?.value ?? []);
      resetConfigDashboardTypes({configDashboardTypes:configTypes})
    }
    if(resetNavOptions !== false){ 
      setActiveConfigType("");
    }
    getNavbarConfigTypes();
  },[])
  return (
    <div className='adminPanelContainer'>
        <ConfigurationDashboardNavbar />
        <div className='adminPanelInnerComponentContainer'>
            <div className='adminPanelInnerComponent'>
            {children}
            </div>
        </div>
    </div>
  )
}

export default AdminPanelLayout;